import { handleFormClick } from '@/lib/functions';
import { Button } from './Button';
import { Icon } from './Icon';

export const CallToAction = ({ contact }: { contact: any }) => {
  return (
    <section className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
        <img className="mx-auto w-72" src={'/images/illustrations/sunrise.svg'} alt="" />
        <h2 className="h1 mx-auto mt-6 max-w-3xl text-center text-green-900">
          <span className="block">Өнөөдрийн суралцагч</span>
          <span className="relative block">
            <span className="relative">
              <img
                className="absolute inset-0 translate-y-9 transform sm:translate-y-11 xl:translate-y-14"
                src={'/images/illustrations/underline-simple-light-green.svg'}
                alt=""
              />
              <span className="relative">Маргаашийг манлайлна</span>
            </span>
          </span>
        </h2>
        <div className="mt-12 flex justify-center xl:mt-14">
          <Button onClick={() => handleFormClick(contact.registration)}>
            Бүртгүүлэх
            <Icon
              icon="arrowNarrowRight"
              className="ml-3 h-6 w-6 group-hover:animate-horizontal-bounce"
              stroke={2}
            />
          </Button>
        </div>
      </div>
    </section>
  );
};
